/**
 * Copyright © 2026 Adnuntius AS.
 */
import {Component, Input} from '@angular/core';
import {TeamGroupListPageComponent} from './team-group-list-page.component';

@Component({
  standalone: true,
  imports: [TeamGroupListPageComponent],
  selector: 'adn-team-group-route-page',
  template: `
    <adn-team-group-list-page
      [readOnly]="readOnly">
    </adn-team-group-list-page>
  `
})
export class TeamGroupRoutePageComponent {
  @Input() readOnly = false;
}
